import { render, staticRenderFns } from "./ButtonPanel.vue?vue&type=template&id=08f4e444&scoped=true&"
import script from "./ButtonPanel.vue?vue&type=script&lang=ts&"
export * from "./ButtonPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPanel.vue?vue&type=style&index=0&id=08f4e444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4e444",
  null
  
)

export default component.exports